// Returns the number of seconds to display in the Watch History "Watched"
// column: the seconds actually watched (getWatchedProgress), capped at the
// video length. Progress % and the status badge are derived from the same
// number, so the three columns always agree.
//
// The cumulative play-time (`dailyBreakdown` sum) is a different, wall-clock
// quantity (re-watches count again, 2x speed counts half) and stays in the
// stat cards (Platform Time / Playtime) and the CSV export.
const getWatchedSeconds = (watchedSeconds, video) => {
  const position = Number(watchedSeconds);
  const length = Number(video?.videoLength);
  if (!Number.isFinite(position) || position <= 0) return 0;
  if (Number.isFinite(length) && length > 0) return Math.min(position, length);
  return position;
};

export default getWatchedSeconds;
